import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const homepageService = createApi({
  reducerPath: "homepage",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/",
  }),
  endpoints: (builder) => ({
    homepage: builder.query({
      query: () => ({
        url: "homepage",
        method: "GET",
      }),
    }),
  }),
});

export const { useHomepageQuery } = homepageService;
export default homepageService;